// extracted by mini-css-extract-plugin
export var copyableField = "_pg-4";
export var customerBadge = "_pg-0";
export var customerInfoTitle = "_pg-2";
export var details = "_pg-1";
export var dropdownContainer = "_pg-5";
export var dropdownImage = "_pg-6";
export var editAssigneeForm = "_pg-a";
export var editButton = "_pg-3";
export var email = "_pg-7";
export var hidden = "_pg-d";
export var input = "_pg-8";
export var saveButton = "_pg-b";
export var shopifyIcon = "_pg-c";
export var suggestionBadge = "_pg-e";
export var suggestionText = "_pg-f";
export var username = "_pg-9";